<template>
  <div
    class="app-content-container mx-auto h-full"
    :class="{'app-content-container-boxed': appContentWidth === 'boxed'}"
  >
    <slot></slot>
    <Message></Message>
    <loader></loader>
  </div>
</template>

<script>
import useAppConfig from '../../../app-config/useAppConfig'
import Message from '../../../../components/message'
import Loader from '../../../../components/loader'

export default {
  components: {
    Message,
    Loader,
  },
  setup() {
    const { appContentWidth } = useAppConfig()

    return {
      appContentWidth,
    }
  },
}
</script>

<style lang="scss">
@import '../../../layouts/styles/_variables';

.app-content-container {
  &.app-content-container-boxed {
    max-width: $content-max-width;
  }
}
</style>
